import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '影片分类',
    links: [
      { label: '动作片', href: '/category/action' },
      { label: '喜剧片', href: '/category/comedy' },
      { label: '科幻片', href: '/category/scifi' },
      { label: '爱情片', href: '/category/romance' },
      { label: '恐怖片', href: '/category/horror' },
    ],
  },
  {
    title: '热门推荐',
    links: [
      { label: '动画片', href: '/category/animation' },
      { label: '纪录片', href: '/category/documentary' },
      { label: '电视剧', href: '/category/drama' },
      { label: '最新上线', href: '/category/all?sort=new' },
      { label: '高分推荐', href: '/category/all?sort=rating' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', href: '/about' },
      { label: '联系方式', href: '/about#contact' },
      { label: '影视资讯', href: '/category/all' },
      { label: '观影指南', href: '/category/all' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/50" role="contentinfo">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 no-underline">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-movie-2-line text-primary-500 text-2xl"></i>
              </div>
              <span className="font-heading text-xl text-foreground-50 tracking-wide">窝窝影院</span>
            </Link>
            <p className="text-foreground-500 text-sm leading-relaxed">
              高清播放，在线不缓冲。超清画质无广告，海量电影电视剧免费在线观看，每日更新不卡顿。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-foreground-200 font-heading text-base mb-4">{group.title}</h4>
              <ul className="space-y-2">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-foreground-500 text-sm hover:text-primary-400 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-200/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-600 text-xs">
            &copy; {new Date().getFullYear()} 窝窝影院 wowocinema.com - 高清播放在线不缓冲，流畅观看超清画质无广告
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-600 text-xs hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="text-foreground-600 text-xs hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}